export enum SortTypes {
  BEST_SELLING = 1,
  SCORE = 2,
  NUMBER_OF_POINTS = 3,
}

export enum PackageRoutes {
  ELEMENTARY_SCHOOL = "elementary-school-packages",
  MIDDLE_SCHOOL = "middle-school-packages",
  HIGHSCHOOL = "highschool-packages",
}

export enum StatusPack {
  ACTIVE = 1,
  WILL_BE_ACTIVATED = 2,
  DISABLED = 3,
  HAS_NOT = 4,
  SUSPEND = 5,
  NO_DEMO_OR_ORIGINAL_CONSTRACT = 6,
  USING_FREE_DEMO = 7,
}

export enum SeriesEnum {
  GENERAL = 19,
  NOROUZ_LEAGUE = 22,
  SMART_TUTOR = 23,
  SIXTH_GRADE_VIP_TIZHOSHAN_EXAM = 24,
  KONKOUR_SIMULATOR_1402 = 25,
  KONKOUR_SIMULATOR_1403 = 26,
}

export enum ContentType {
  PRACTICE = 1,
  LECTURE = 2,
  EXAM = 3,
  VIDEO = 4,
  VOICE = 5,
  PDF = 6,
  DESCRIPTIVE_PRACTICE = 7,
}
